import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { EnvService } from '../services/env/env.service';

@Injectable()
export class CacheInterceptor implements HttpInterceptor {
  private cache: Map<
    string,
    {
      expiryDate: Date;
      response: HttpResponse<any>;
    }
  > = new Map();

  constructor(private envService: EnvService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const url = req.url.replace(this.envService.apiUrl, '').toLowerCase();
    if (req.method !== 'GET' || !this.canCacheEndpoint(url)) {
      return next.handle(req);
    }

    const cachedResponse = this.cache.get(req.url);
    if (cachedResponse && cachedResponse.expiryDate <= new Date()) {
      this.cache.delete(req.url);
      return this.sendRequest(req, next);
    }

    return cachedResponse
      ? of(cachedResponse.response)
      : this.sendRequest(req, next);
  }

  private canCacheEndpoint(url: string) {
    const endPointsToCache = ['v1/forecast:daily', 'v1/forecast:hourly'];
    for (let i = 0; i < endPointsToCache.length; i++) {
      if (url.includes(endPointsToCache[i])) return true;
    }
    return false;
  }

  private sendRequest(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap(event => {
        if (event instanceof HttpResponse) {
          const hoursToAdd = 24;
          this.cache.set(request.url, {
            expiryDate: this.addHoursTodaysDate(hoursToAdd),
            response: event
          });
        }
      })
    );
  }

  private addHoursTodaysDate(hours: number) {
    const expiryDate = new Date();
    expiryDate.setHours(expiryDate.getHours() + hours);
    return expiryDate;
  }
}
